import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import PropTypes from 'prop-types';
// assets
import arrow from '../assets/arrow.png';
const Nav = ({ content }) => {

    const { name, url } = content;

return (
            
            <div className={styles.nav}>
                <div className={styles.navTitle}>
                    {/* <a href={url}> */}
                        {name}
                    {/* </a> */}
                </div>
                <div className={styles.navMore}>
                    {/* <div className={styles.navMoreText}>
                        <a href={url}>
                            更多
                        </a>
                    </div>
                    <div>
                        <img src={arrow} alt="" className={styles.navMoreIcon} />
                    </div> */}
                    
                </div>
            </div>

    );
};

Nav.propTypes = {
    content: PropTypes.object,
};
export default errorBoundary(Nav);

